import React from "react";

const AssignmentText = (props) => {
    return (
        <>
        <div class="row rowAssessment">
            <div class="col-12 assessment-col-left">
                <div class="d-flex flex-wrap assMentbox">
                    <div>
                    <b>Conditions of appeal text:</b>
                    </div>
                    <div class="flex-shrink">
                        <p><em>I have read and understand the terms of the appeal process.</em></p>
                        <br />
                        <p><em>To obtain a comprehensive understanding of the regulations and requirements related to appeals and extenuating circumstances, we recommend consulting the corresponding programme handbook/assessment policy.</em></p>
                        <br />
                        <p><em>By submitting this appeal, you agree that you have read and understand the terms of the appeal process.</em></p>
                    </div>
                </div>
            </div>
        </div>  
         </>
    );
}
export default AssignmentText;
